"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _RoutingRule_1 = require("./_RoutingRule");
exports._RoutingRules = {
    type: "list",
    member: {
        shape: _RoutingRule_1._RoutingRule,
        locationName: "RoutingRule"
    }
};
//# sourceMappingURL=_RoutingRules.js.map